/*                                                  */
import { hydrate_node, hydrating, set_hydrate_node } from './hydration.js';
import { DEV } from 'esm-env';
import { init_array_prototype_warnings } from '../dev/equality.js';
import { get_descriptor, is_extensible } from '../../shared/utils.js';
import { active_effect } from '../runtime.js';
import { async_mode_flag } from '../../flags/index.js';
import { TEXT_NODE, EFFECT_RAN } from '#client/constants';
import { eager_block_effects } from '../reactivity/batch.js';

/*                                                                                            */
/*                 */
export var $window;

/*                   */
export var $document;

/*                  */
export var is_firefox;

/*                            */
var first_child_getter;
/*                            */
var next_sibling_getter;

/**
 *
 *
 */
export function init_operations() {
	if ($window !== undefined) {
		return;
	}

	$window = window;
	$document = document;
	is_firefox = /Firefox/.test(navigator.userAgent);

	var element_prototype = Element.prototype;
	var node_prototype = Node.prototype;
	var text_prototype = Text.prototype;

	/*         */
	first_child_getter = get_descriptor(node_prototype, 'firstChild').get;
	/*         */
	next_sibling_getter = get_descriptor(node_prototype, 'nextSibling').get;

	if (is_extensible(element_prototype)) {
		/*                                                             */
		/*               */
		element_prototype.__click = undefined;
		/*               */
		element_prototype.__className = undefined;
		/*               */
		element_prototype.__attributes = null;
		/*               */
		element_prototype.__style = undefined;
		/*               */
		element_prototype.__e = undefined;
	}

	if (is_extensible(text_prototype)) {
		/*               */
		text_prototype.__t = undefined;
	}

	if (DEV) {
		/*               */
		element_prototype.__svelte_meta = null;

		init_array_prototype_warnings();
	}
}

/**
 *
 *
 */
export function create_text(value = '') {
	return document.createTextNode(value);
}

/**
 *
 *
 *
 */
/*                    */
export function get_first_child(node) {
	return first_child_getter.call(node);
}

/**
 *
 *
 *
 */
/*                    */
export function get_next_sibling(node) {
	return next_sibling_getter.call(node);
}

/**
 *
 *
 *
 *
 *
 */
export function child(node, is_text) {
	if (!hydrating) {
		return get_first_child(node);
	}

	var child = /*                       */ (get_first_child(hydrate_node));

	/*                                                                                                       */
	if (child === null) {
		child = hydrate_node.appendChild(create_text());
	} else if (is_text && child.nodeType !== TEXT_NODE) {
		var text = create_text();
		child?.before(text);
		set_hydrate_node(text);
		return text;
	}

	set_hydrate_node(child);
	return child;
}

/**
 *
 *
 *
 *
 */
export function first_child(fragment, is_text) {
	if (!hydrating) {
		/*                                                                                         */
		var first = /*                           */ (get_first_child(/*               */ (fragment)));

		/*                                                                             */
		if (first instanceof Comment && first.data === '') return get_next_sibling(first);

		return first;
	}

	/*                                                        */
	/*                                                  */
	if (is_text && hydrate_node?.nodeType !== TEXT_NODE) {
		var text = create_text();

		hydrate_node?.before(text);
		set_hydrate_node(text);
		return text;
	}

	return hydrate_node;
}

/**
 *
 *
 *
 *
 *
 */
export function sibling(node, count = 1, is_text = false) {
	let next_sibling = hydrating ? hydrate_node : node;
	var last_sibling;

	while (count--) {
		last_sibling = next_sibling;
		next_sibling = /*                       */ (get_next_sibling(next_sibling));
	}

	if (!hydrating) {
		return next_sibling;
	}

	/*                                                               */
	/*                                                  */
	if (is_text && next_sibling?.nodeType !== TEXT_NODE) {
		var text = create_text();
		/*                                                                      */
		/*                                                                        */
		/*                                        */
		if (next_sibling === null) {
			last_sibling?.after(text);
		} else {
			next_sibling.before(text);
		}
		set_hydrate_node(text);
		return text;
	}

	set_hydrate_node(next_sibling);
	return /*                       */ (next_sibling);
}

/**
 *
 *
 *
 */
export function clear_text_content(node) {
	node.textContent = '';
}

/**
 *
 *
 *
 *
 */
export function should_defer_append() {
	if (!async_mode_flag) return false;
	if (eager_block_effects !== null) return false;

	var flags = /*                 */ (active_effect).f;
	return (flags & EFFECT_RAN) !== 0;
}

/**
 *
 *
 *
 *
 *
 */
export function create_element(tag, namespace, is) {
	let options = is ? { is } : undefined;
	if (namespace) {
		return document.createElementNS(namespace, tag, options);
	}
	return document.createElement(tag, options);
}

export function create_fragment() {
	return document.createDocumentFragment();
}

/**
 *
 *
 */
export function create_comment(data = '') {
	return document.createComment(data);
}

/**
 *
 *
 *
 *
 */
export function set_attribute(element, key, value = '') {
	if (key.startsWith('xlink:')) {
		element.setAttributeNS('http:/*                                  */
		return;
	}
	return element.setAttribute(key, value);
}
